import { action, observable, makeAutoObservable } from 'mobx';
import {
    AutotraderLogsErrorKind,
    AutotraderLogsEventsOverviewKind,
} from 'src/components/AutomationTrading/AutomationItem/HistoryItem';

export type AutomationEventsType = {
    type: 'events';
    data: AutotraderLogsEventsOverviewKind;
};

export type AutomationLogsType = {
    type: 'logs';
    data: Array<AutotraderLogsErrorKind>;
};

export type AutomationPopupTypes = AutomationEventsType | AutomationLogsType;

export class AutomationPopupState {
    @observable public isOpen: AutomationPopupTypes | null = null;
    constructor() {
        makeAutoObservable(this);
    }
    @action public open = (popupData: AutomationPopupTypes | null): void => {
        this.isOpen = popupData;
    };

    @action public close = (): void => {
        this.isOpen = null;
    };
}
